"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Create = void 0;
var react_1 = __importDefault(require("react"));
var react_cookie_1 = require("react-cookie");
var structure_1 = require("remota-client/component/structure");
var panel_1 = require("remota-client/component/panel");
var form_1 = require("remota-client/component/form");
var button_1 = require("remota-client/component/button");
var enum_1 = require("remota-common/enum");
var const_1 = require("remota-common/const");
var auth_1 = require("app/hook/auth");
var Create = function (props) {
    var resetToken = props.match.params.token;
    var _a = __read((0, auth_1.useCheckPassword)(resetToken), 3), check = _a[0], checkResult = _a[1], checkStatus = _a[2];
    var _b = __read((0, auth_1.useResetPassword)(resetToken), 3), reset = _b[0], token = _b[1], resetStatus = _b[2];
    var _c = __read((0, auth_1.useGetLoginInfo)(resetToken), 1), loginInfo = _c[0];
    var _d = __read(react_1.default.useState({
        new1: "",
        new2: "",
        checking: "",
    }), 2), state = _d[0], setState = _d[1];
    var setCookie = (0, react_cookie_1.useCookies)([const_1.TOKEN_COOKIE_NAME])[1];
    var handleChange = react_1.default.useCallback(function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setState(function (state) {
            var _a;
            return (__assign(__assign({}, state), (_a = {}, _a[name] = value, _a)));
        });
    }, [setState]);
    if (state.new1 !== state.checking && state.new1 !== "" && !checkStatus.isLoading) {
        check({ credential: state.new1 });
        setState(__assign(__assign({}, state), { checking: state.new1 }));
    }
    // 送信時に完全にパスワードの再確認との照合は行っていないので、フロント側でボタン押下の制御にぶちこむ。 ms1877
    var handleSubmit = react_1.default.useCallback(function () {
        return reset({
            credential: state.new1,
            authType: enum_1.AuthType.PASSWORD,
        });
    }, [reset, state.new1]);
    //一致しているかチェックする
    var isValid = !resetStatus.isLoading &&
        !!state.new1 &&
        !!state.new2 &&
        state.new1 === state.new2 &&
        state.new1 === state.checking &&
        checkResult &&
        !checkResult.isVulnerable &&
        !checkStatus.error;
    // checkStatusもいれてみる ms1878
    if (token && !resetStatus.error && !resetStatus.isLoading && !checkStatus.error) {
        // TODO: 有効期限など
        setCookie(const_1.TOKEN_COOKIE_NAME, token, { path: "/" });
        // もうちょっとかっこいいリダイレクトはないものか
        window.location.assign("/");
    }
    return (react_1.default.createElement(structure_1.PlainStructure, { center: true },
        react_1.default.createElement(panel_1.LogoPanel, { width: 600 },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u30C6\u30CA\u30F3\u30C8\u30B3\u30FC\u30C9" }, !loginInfo ? null : loginInfo.tenantCode),
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u30E6\u30FC\u30B6ID" }, !loginInfo ? null : loginInfo.userCode),
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u30D1\u30B9\u30EF\u30FC\u30C9" },
                react_1.default.createElement(form_1.BoxInput, { type: "password", name: "new1", value: state.new1, error: resetStatus.error !== null, onChange: handleChange }),
                !checkResult || !checkResult.isVulnerable || state.new1 === "" ? null : (react_1.default.createElement(react_1.default.Fragment, null, checkResult.messages.map(function (message, i) { return (react_1.default.createElement(form_1.Message, { key: i, error: true }, message)); })))),
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u30D1\u30B9\u30EF\u30FC\u30C9\uFF08\u518D\u5165\u529B\uFF09" },
                react_1.default.createElement(form_1.BoxInput, { type: "password", name: "new2", value: state.new2, error: resetStatus.error !== null, onChange: handleChange }),
                state.new1 === state.new2 || state.new2 === "" ? null : (react_1.default.createElement(form_1.Message, { error: true }, "2\u3064\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093"))),
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(button_1.AccentButton, { thin: true, disabled: !isValid, onClick: handleSubmit, width: "100%" }, "\u8A2D\u5B9A")))));
};
exports.Create = Create;
